<ion-item [button]="button" [detail]="detail" [lines]="lines" (click)="onItemClick()">
  @if (showBookmark) {
    <ion-button
      slot="start"
      fill="clear"
      size="large"
      (click)="onBookmarkToggle($event)"
      [disabled]="isTogglingBookmark"
      [attr.aria-label]="isBookmarked ? 'Remove bookmark' : 'Bookmark workspace'"
    >
      <ion-icon
        [name]="isBookmarked ? 'star' : 'star-outline'"
        slot="icon-only"
        [style.color]="isBookmarked ? 'var(--ion-color-warning)' : ''"
      ></ion-icon>
    </ion-button>
  }
  @if (showThumbnailImage) {
    <ion-thumbnail slot="start" class="workspace-thumbnail">
      <ion-img
        [src]="thumbnailUrl!"
        (ionError)="onThumbnailError()"
        (ionImgDidLoad)="$event.target.classList.add('loaded')"
        class="thumbnail-image"
      ></ion-img>
    </ion-thumbnail>
  } @else {
    <ion-icon slot="start" name="file-tray-stacked" class="workspace-fallback-icon"></ion-icon>
  }
  <ion-label>
    <h2>{{ workspaceName }}</h2>
    <!-- Revisit: meta block was
      @if (createdAt) {
        <p style="color: var(--app-muted-text)">
          <small>
            Created: {{ formatDate(createdAt) }}
            @if (createdByEmail) { • By: {{ createdByEmail }} }
          </small>
        </p>
      }
    -->
  </ion-label>
  @if (status) {
    <ion-badge slot="end" [color]="getBadgeColor(status)">{{ getBadgeText(status) }}</ion-badge>
  }
</ion-item>
